(function () {
	document.addEventListener('keyup', e => {
		if (e.keyCode === 49 && e.altKey === true) {
			window.location.href = '/';
		}
	});
}());
